import { LoginPage } from '@modules/user';
import { redirect } from '@remix-run/server-runtime';
import {
    isCleanRedirect,
    type DataFunctionArgs,
    type APHandle,
} from '~/modules/root';
import { getSession } from '~/modules/root/util/session.server';
import { createOGTags, getCanonicalHreflang, mergeMeta } from '~/modules/seo';
import { redirectBack } from 'remix-utils';

export const meta = mergeMeta<typeof loader>(
    () => {
        return [];
    },
    (props) => {
        const title = 'Login to ArchiPro';
        return [
            {
                title,
                ...getCanonicalHreflang(props),
                ...createOGTags({
                    meta: props,
                    title,
                }),
            },
        ];
    }
);

export const shouldRevalidate = () => {
    return false;
};

export const loader = async (args: DataFunctionArgs) => {
    const { context, request } = args;
    const [user, session] = await Promise.all([
        context.getUser(),
        getSession(request),
    ]);
    if (user.__typename === 'Me') {
        const url = new URL(request.url);
        const redirectParam = url.searchParams.get('redirect');
        if (redirectParam && isCleanRedirect(redirectParam)) {
            let redirectUrl = decodeURI(redirectParam);
            if (!redirectUrl.startsWith('/')) {
                redirectUrl = `/${redirectUrl}`;
            }
            throw redirect(redirectUrl, {
                headers: await session.getHeaders(),
            });
        }
        session.flashToastMessage({
            type: 'notification',
            message: `You are already logged in`,
        });
        if (url.pathname === '/login' || url.pathname === '/login-test') {
            throw redirect('/', { headers: await session.getHeaders() });
        }
        throw redirectBack(request, {
            fallback: '/',
            headers: await session.getHeaders(),
        });
    }
    return {};
};

export const handle: APHandle = {
    hideTopNavigation: {
        desktop: true,
        tablet: true,
        mobile: true,
    },
    hideFooter: {
        desktop: true,
        tablet: true,
        mobile: true,
    },
};

export default LoginPage;
